/* eslint-disable import/prefer-default-export */
const UpgradeAccountActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  UPDATE_VERIFICATION_NOTES_STATUS: 'update_verification_notes_status',
  UPDATE_VERIFICATION_NOTES_TYPE: 'update_verification_notes_type',
  UPDATE_TIERS_STANDARD: 'update_tiers_standard',
  UPDATE_CURRENT_TIER: 'update_current_tier',
  UPDATE_NEXT_TIER_INFO: 'update_next_tier_info',
  UPDATE_USER_RISK_TIER: 'update_user_risk_tier',
  UPDATE_SELECTED_SOURCE_OF_WEALTH: 'update_selected_source_of_wealth',
  UPDATE_SELECTED_BUSINESS_SECTOR: 'update_selected_business_sector',
};

const UpgradeAccountReducer = (state, action) => {
  switch (action.type) {
    case UpgradeAccountActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case UpgradeAccountActionTypes.UPDATE_VERIFICATION_NOTES_STATUS:
      return { ...state, verificationNoteOpened: action.payload };
    case UpgradeAccountActionTypes.UPDATE_VERIFICATION_NOTES_TYPE:
      return { ...state, verificationNoteType: action.payload };
    case UpgradeAccountActionTypes.UPDATE_TIERS_STANDARD:
      return { ...state, tiersStandard: action.payload };
    case UpgradeAccountActionTypes.UPDATE_CURRENT_TIER:
      return { ...state, currentTier: action.payload };
    case UpgradeAccountActionTypes.UPDATE_NEXT_TIER_INFO:
      return { ...state, nextTierInfo: action.payload };
    case UpgradeAccountActionTypes.UPDATE_USER_RISK_TIER:
      return { ...state, riskTier: action.payload };
    case UpgradeAccountActionTypes.UPDATE_SELECTED_SOURCE_OF_WEALTH:
      return { ...state, selectedSourceOfWealth: action.payload };
    case UpgradeAccountActionTypes.UPDATE_SELECTED_BUSINESS_SECTOR:
      return { ...state, selectedBusinessSector: action.payload };
    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: UpgradeAccountActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const openVerificationNotes = (dispatch) => () =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_VERIFICATION_NOTES_STATUS, payload: true });

const closeVerificationNotes = (dispatch) => () =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_VERIFICATION_NOTES_STATUS, payload: false });

const updateTiersStandard = (dispatch) => (tiersStandard) =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_TIERS_STANDARD, payload: tiersStandard });
const updateCurrentTier = (dispatch) => (currentTier) =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_CURRENT_TIER, payload: currentTier });

const updateNextTierInfo = (dispatch) => (nextTierInfo) =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_NEXT_TIER_INFO, payload: nextTierInfo });

const updateVerificationNotesType = (dispatch) => (type) =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_VERIFICATION_NOTES_TYPE, payload: type });

const updateUserRiskTier = (dispatch) => (riskTier) =>
  dispatch({ type: UpgradeAccountActionTypes.UPDATE_USER_RISK_TIER, payload: riskTier });

const updateSelectedSourceOfWealth = (dispatch) => (sourceOfWealthKey) =>
  dispatch({
    type: UpgradeAccountActionTypes.UPDATE_SELECTED_SOURCE_OF_WEALTH,
    payload: sourceOfWealthKey,
  });

const updateSelectedBusinessSector = (dispatch) => (businessSectorKey) =>
  dispatch({
    type: UpgradeAccountActionTypes.UPDATE_SELECTED_BUSINESS_SECTOR,
    payload: businessSectorKey,
  });

export const upgradeAccount = {
  UpgradeAccountReducer,
  actions: {
    openScreen,
    openVerificationNotes,
    closeVerificationNotes,
    updateTiersStandard,
    updateCurrentTier,
    updateNextTierInfo,
    updateVerificationNotesType,
    updateUserRiskTier,
    updateSelectedSourceOfWealth,
    updateSelectedBusinessSector,
  },
};
